"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _validator = _interopRequireDefault(require("validator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isInt = function isInt(message) {
  return function (_ref) {
    var field = _ref.field;

    if (!field.value) {
      return true;
    }

    var isValid = _validator.default.isInt(field.value);

    return [isValid, message || 'Please enter an integer.'];
  };
};

var _default = isInt;
exports.default = _default;
//# sourceMappingURL=isInt.js.map